import React from 'react';
import {dropdownFillBlack} from 'assets/images/images';
import {Accordion} from '../../../components';
import {DetailRow} from './DetailRow';

function NetworkAndRelationship({data = {}}) {
  const {counterparty_overview = {}, risk_relationships = {}} = data;

  return (
    <div className="bg-white rounded-xl py-4 flex flex-col gap-4">
      <div className="px-6 flex flex-col gap-1">
        <h4 className="text-deepBlue font-medium">
          Network & Relationship Analysis
        </h4>
      </div>

      <div className="px-3 flex flex-col gap-4">
        <Accordion
          customTitleSize="text-tiny text-deepBlue font-medium leading-[16px]"
          customClasses="border border-[#F3F4F7] rounded-[12px]"
          customPadding="p-3 flex-col md:flex-row h-11 !items-start"
          customImg={dropdownFillBlack}
          title="Counterparty Overview"
        >
          <div className="mt-1">
            <h5 className="text-xs text-[#5C688E] font-bold tracking-wider uppercase pt-1 pb-4">
              UNIQUE COUNTERPARTIES
            </h5>
            <DetailRow
              label="Total number of senders or receivers"
              value={counterparty_overview.total_number_of_senders_or_receivers}
            />

            <h5 className="text-xs text-[#5C688E] font-bold tracking-wider uppercase pt-4 pb-4 border-t border-[#F6F7F9]">
              MERCHANT EXPOSURE
            </h5>
            <DetailRow
              label="Count of merchants and share of high-risk ones"
              value={
                counterparty_overview.count_of_merchants_and_share_of_high_risk_ones
              }
            />

            <h5 className="text-xs text-[#5C688E] font-bold tracking-wider uppercase pt-4 pb-4 border-t border-[#F6F7F9]">
              SHARED DATA LINKS
            </h5>
            <DetailRow
              label="Number of overlaps"
              value={counterparty_overview.number_of_overlaps}
            />
          </div>
        </Accordion>

        <Accordion
          customTitleSize="text-tiny text-deepBlue font-medium leading-[16px]"
          customClasses="border border-[#F3F4F7] rounded-[12px]"
          customPadding="p-3 flex-col md:flex-row h-11 !items-start"
          customImg={dropdownFillBlack}
          title="Risk Relationships"
        >
          <div className="mt-1">
            <h5 className="text-xs text-[#5C688E] font-bold tracking-wider uppercase pt-1 pb-4">
              COUNTERPARTY RISK SCORE
            </h5>
            <DetailRow
              label="Weighted risk derived from linked profiles"
              value={
                risk_relationships.weighted_risk_derived_from_linked_profiles
              }
            />

            <h5 className="text-xs text-[#5C688E] font-bold tracking-wider uppercase pt-4 pb-4 border-t border-[#F6F7F9]">
              HIGH-RISK CONNECTIONS
            </h5>
            <DetailRow
              label="List of entities previously flagged for fraud or anomalies."
              value={
                risk_relationships.list_of_entities_previously_flagged_for_fraud_or_anomalies
              }
            />

            <h5 className="text-xs text-[#5C688E] font-bold tracking-wider uppercase pt-4 pb-4 border-t border-[#F6F7F9]">
              RECIPROCITY RATIO
            </h5>
            <DetailRow
              label="Balance between one-way and two-way transactions"
              value={
                risk_relationships.balance_between_one_way_and_two_way_transactions
              }
            />
          </div>
        </Accordion>

        <Accordion
          customTitleSize="text-tiny text-deepBlue font-medium leading-[16px]"
          customClasses="border border-[#F3F4F7] rounded-[12px]"
          customPadding="p-3 flex-col md:flex-row h-11 !items-start"
          customImg={dropdownFillBlack}
          title="Network Flags"
        >
          <div className="mt-1">
            <p className="text-small text-[#858DAA] capitalize py-2 border-[0.5px] border-transparent border-b-[#F6F7F9]">
              Linked to flagged account
            </p>
            <p className="text-small text-[#858DAA] capitalize py-2 border-[0.5px] border-transparent border-b-[#F6F7F9]">
              Unusual receiver network density
            </p>
          </div>
        </Accordion>
      </div>
    </div>
  );
}

export default NetworkAndRelationship;
